define([
  'immutable',
  'es6!sumo/util',
  'es6!launcher/actions/segments/Actions',
], (
  Immutable, Util, Actions,
) => {
  const initialState = Immutable.Map({
    emails: Immutable.List(),
    segment: null,
    segments: Immutable.List(),
    segmentContacts: Immutable.Map(),
    segmentEstimates: Immutable.Map(),
    total: 0,
    loading: true,
  });

  const actionHandlers = {};

  actionHandlers[Actions.UPDATE_SEGMENTS_SETTING] = (state, action) => {
    const { setting, value } = action;
    if (Array.isArray(setting)) return state.setIn(setting, value);
    return state.set(setting, value);
  };

  actionHandlers[Actions.RECEIVE_SEGMENT_EMAILS] = (state, action) => {
    const { emails } = action;
    return state.set('emails', Immutable.fromJS(emails));
  };

  actionHandlers[Actions.RECEIVE_SEGMENT_CONTACTS] = (state, action) => {
    const { segmentId, contacts } = action;
    return state
      .setIn(['segmentContacts', segmentId], Immutable.fromJS(contacts || []))
      .set('loading', false);
  };

  actionHandlers[Actions.RECEIVE_SEGMENT_ESTIMATE] = (state, action) => {
    const { id, count } = action;
    return state.setIn(['segmentEstimates', id], count);
  };

  actionHandlers[Actions.RECEIVE_SEGMENT] = (state, action) => {
    const segment = Immutable.fromJS(action.segment);

    let newState = state;
    newState.get('segments').forEach((s, i) => {
      if (s.get('id') === segment.get('id')) {
        newState = newState.setIn(['segments', i], segment);
      }
    });

    return newState.set('segment', segment);
  };

  actionHandlers[Actions.RECEIVE_SEGMENTS] = (state, action) => {
    const { total, segments } = action.data;

    return state.merge(
      Immutable.fromJS({
        total,
        segments,
      }),
    );
  };

  actionHandlers[Actions.REMOVE_SEGMENT] = (state, action) => {
    const { segmentId } = action;

    const segments = state.get('segments');
    const segment = state.get('segment');

    let newState = state;
    if (segment && segment.get('id') === segmentId) {
      newState = newState.set('segment', null);
    }

    return newState.set('segments', segments.filter(s => s.get('id') !== segmentId));
  };

  return Util.createReducer(initialState, actionHandlers);
});
